import React from 'react';
import styled from 'styled-components';

const TagContainer = styled.span`
  padding: 3px 10px;
  border-radius: 15px;
  background-color: #d5d5d5;
  color: #3f3f3f;
  font-size: 11px;
  font-family: 'Arial Nova', Arial, Helvetica, sans-serif;
  display: inline-block;
  margin-top: 4px;
  line-height: 1.3;
  word-wrap: break-word;
  hyphens: auto;
`;

const Tag = ({ children, ...props }) => {
  return (
    <TagContainer {...props}>
      {children}
    </TagContainer>
  );
};

export default Tag;
